'use strict';

exports.decode = exports.parse = require('./decode');
exports.encode = exports.stringify = require('./encode');



//////////////////
// WEBPACK FOOTER
// /Users/eulo/repos/CodeDrips/round3/wp-content/themes/round3/node_modules/querystring-es3/index.js
// module id = 14
// module chunks = 0 1